import * as React from 'react';
import * as userService from '../../../services/user.service';
import NotifyHOC from '../../../HOC/Notifications';
import { User } from '../../../interface/user.interface';
import { uppercaseFirstLetter } from '@nexxt/common/services/TextService';
import * as role from '../../../mapping/roles';
import Select from 'react-select';
import { Formik, Form } from 'formik';
import TextField from '../../common/textField';
import IndicatorsContainer from '../../common/reactSelect/IndicatorsContainer';

import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalTitle
} from '../../common/modal';

interface IEditUserProps {
    user: any;
    tenantId: number;
    isEditUser: boolean;
    toastNotification: any;
    toggleEditUser: () => void;
    getUsers: (tenantId: number) => void;
}

interface IEditUserState {
    tenantId: number;
    accessType: string;
    selectedOption: any;
    isRequesting: boolean;
    users: User[];
    isSelected: boolean;
}

class EditUser extends React.Component<IEditUserProps, IEditUserState> {
    constructor(props) {
        super(props);
        this.state = {
            users: [],
            isRequesting: false,
            tenantId: null,
            selectedOption: null,
            accessType: role.mapping[this.props.user.AccessType], //props set
            isSelected: false
        };
    }

    onClose = () => {
        this.props.toggleEditUser();
    };

    handleChange = (selectedOption) => {
        this.setState({
            selectedOption,
            accessType: selectedOption.value,
            isSelected: true
        });
    };

    handleSubmit = async (values: any) => {
        this.editUser(values);
    };

    editUser = async (values) => {
        this.setState({
            isRequesting: true
        });
        const data = {
            accessType: this.state.accessType
        };

        try {
            await userService.updateRole(this.props.user.UserID, data);
            this.setState({
                isRequesting: false
            });
            this.props.toggleEditUser();

            this.props.toastNotification.success(
                `Successfully edited user ${uppercaseFirstLetter(
                    this.props.user.firstName
                )}'s role to  ${role.mapping[this.state.accessType]}`
            );
            this.props.getUsers(this.props.tenantId);
        } catch (error) {
            this.setState({
                isRequesting: false
            });
            this.props.toastNotification.error(
                "Unable to change own's access type "
            );
        }
    };

    render() {
        const { isRequesting, selectedOption, isSelected } = this.state;
        const { user } = this.props;

        return (
            <Modal className="modal__heightauto" isOpen={true}>
                <ModalHeader onClose={this.onClose}>
                    <ModalTitle>Edit user</ModalTitle>
                </ModalHeader>
                <Formik
                    initialValues={{
                        accessType: ''
                    }}
                    // validationSchema={createUserValidationSchema}
                    onSubmit={(values, actions) => {
                        this.handleSubmit(values);
                    }}
                    render={({
                        values,
                        touched,
                        handleChange,
                        handleBlur,
                        errors,
                        dirty,
                        isSubmitting
                    }) => (
                        <Form>
                            <ModalBody>
                                <TextField
                                    name="email"
                                    value={user.email}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    label="Email"
                                    disabled={true}
                                />
                                <TextField
                                    type="text"
                                    name="firstName"
                                    value={user.firstName}
                                    label="First Name"
                                    disabled={true}
                                />
                                <TextField
                                    type="text"
                                    name="lastName"
                                    value={user.lastName}
                                    label="Last Name"
                                    disabled={true}
                                />
                                <TextField
                                    type="text"
                                    name="company"
                                    value={user.company}
                                    label="Company"
                                    disabled={true}
                                />{' '}
                                <TextField
                                    type="text"
                                    name="jobTitle"
                                    value={user.jobTitle}
                                    label="Job Title"
                                    disabled={true}
                                />
                                <div className="form-group">
                                    <label className="form-group__label form-group--block">
                                        Account type
                                    </label>
                                    <Select
                                        className="react-select"
                                        classNamePrefix="react-select"
                                        name="accessType"
                                        value={
                                            isSelected
                                                ? selectedOption
                                                : {
                                                      label: this.state
                                                          .accessType,
                                                      value: 0
                                                  }
                                        }
                                        options={role.options}
                                        onChange={this.handleChange}
                                        placehodler="Select access type"
                                        components={{
                                            IndicatorsContainer
                                        }}
                                    />
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <button
                                    className="btn btn--sm btn--transparent m-r-10"
                                    onClick={() => this.props.toggleEditUser()}
                                >
                                    Cancel
                                </button>
                                <button
                                    disabled={isSubmitting || isRequesting}
                                    className="btn btn--sm btn--blue"
                                    type="submit"
                                >
                                    {isRequesting ? 'Saving user' : 'Save'}
                                </button>
                            </ModalFooter>
                        </Form>
                    )}
                />
            </Modal>
        );
    }
}

export default NotifyHOC(EditUser);
